// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 936) return "static/chunks/common-33575219-382fd4fd1fdcfba0.js";
	if (chunkId === 3602) return "static/chunks/common-2945abbf-c3d0b8a56f536805.js";
	if (chunkId === 1221) return "static/chunks/common-91059ad5-62e2a9522dbac7f6.js";
	if (chunkId === 4937) return "static/chunks/common-97e3b44b-497adb3eba2f09ef.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"135":"4323bb70605b1061","426":"e4431f72b64cc8e6","2516":"285018df9d589305","4470":"c9a2f522f59e1bbf","6650":"beb2773236fe66d8","8045":"6e44c821b2ba56b3"}[chunkId] + ".js";
};